import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_METRICS_FAILED,
  GET_AZURE_METRICS_FAILED_SUCCESS,
  GET_AZURE_METRICS_FAILED_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureMetricsFailedList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureMetricsFailedStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_METRICS_FAILED:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_METRICS_FAILED_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureMetricsFailedList: action.data,
        error: null,
      };
    case GET_AZURE_METRICS_FAILED_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
